import AxiosInstance from 'utils/AxiosInstance'
import moment from 'moment'
import * as types from './constants'

export const setSearchValue = (value) => ({
	type: types.SET_SEARCH_VALUE,
	searchValue: value,
})
export const selectPastDue = (pastDue) => ({
	type: types.SET_PAST_DUE,
	selectedPastDue: pastDue ? pastDue.option.name : null,
})

export const fetchStatuses = () => {
	return (dispatch) => {
		AxiosInstance.get(`/courses/progress-status`).then((data) => {
			data[-1] = 'Past Due'
			delete data[5]
			delete data[2]
			let statuses = []
			Object.entries(data).map((value) =>
				statuses.push({ status: value[0], name: value[1] })
			)
			dispatch({ type: types.SET_STATUSES, statuses: statuses })
		})
	}
}

export const selectStatus = (statuses) => {
	return (dispatch) => {
		let statusesNum = []
		statuses.map((value) => statusesNum.push(parseInt(value.option.status)))

		dispatch({ type: types.SET_SELECTED_STATUESES, statuses: statuses })
		dispatch({
			type: types.SET_SELECTED_STATUESES_NR,
			selectedStatusesStatus: statusesNum,
		})
	}
}

export const selectCourseType = (courseTypes) => {
	const newCourseTypes = courseTypes.map((course) => course.option)

	return (dispatch) => {
		let values = []
		newCourseTypes.map((item) => values.push(item.value.toString()))

		dispatch({
			type: types.SET_SELECTED_COURSE_TYPE,
			selectedCourseType: newCourseTypes,
		})
		dispatch({
			type: types.SET_SELECTED_COURSE_TYPE_VALUES,
			selectedCourseTypeValues: values,
		})
	}
}

export const setReportLoading = () => ({
	type: types.SET_REPORTS_LOADING,
	value: true,
})

export const groupReportData = () => {
	return (dispatch, getState) => {
		const { userProgress, allCourses } = getState().courses
		const { groupsCoursesAll, userGroupsCoursesAll, groupStatus, allGroups } =
			getState().groups
		let groupData = []
		let coursesData = []
		let individualCourses = []

		if (allGroups.length) {
			allGroups.map((item, index) => {
				groupData[index] = item
				if (userGroupsCoursesAll.length) {
					const courseData = userGroupsCoursesAll.filter(
						(groupCourses) => groupCourses.group_id === item.id
					)
					let groupsCoursesIds = []

					Object.keys(groupsCoursesAll).map(
						(item) =>
							(groupsCoursesIds = [
								...groupsCoursesIds,
								...groupsCoursesAll[item].map((item) => item.course_id),
							])
					)

					individualCourses =
						allCourses && allCourses.length
							? allCourses.filter(
									(item) => groupsCoursesIds.indexOf(item.id) === -1
							  )
							: []

					let itemInfo = groupStatus.find(
						(groupStatusItem) => groupStatusItem.id === item.id
					)
					if (itemInfo) {
						Object.assign(item, {
							status:
								itemInfo['past_due'] === true && itemInfo['status'] < 3
									? -1
									: itemInfo['status'],
							active: item.is_active === 1 ? true : false,
							past_due: itemInfo['past_due'],
							certified_time: itemInfo['certified_time'],
							reassigned: itemInfo['reassigned'],
							expired: itemInfo['expired'],
						})
					}

					Object.assign(item, { courses: [] })
					Object.assign(item, {
						version: item['version']
							? moment(item['version']).format('MM/DD/YYYY')
							: '',
					})

					if (courseData && courseData.length) {
						courseData.map((groupCourses) => {
							let currentCourseData =
								allCourses && allCourses.length
									? allCourses.find(
											(courseId) => courseId.id === groupCourses.course_id
									  )
									: null
							if (currentCourseData) {
								if (userProgress.length) {
									userProgress.find((userProgressItem) =>
										userProgressItem.course_id === currentCourseData.id
											? Object.assign(currentCourseData, {
													certify_time: userProgressItem['certify_time']
														? userProgressItem['certify_time']
														: null,
													status: userProgressItem.status,
													past_due: userProgressItem.past_due,
													equivalent: userProgressItem['equivalent']
														? userProgressItem['equivalent']
														: null,
											  })
											: null
									)
								}
								item['courses'].push(currentCourseData)
								coursesData.push(currentCourseData)
							}
						})
					}
				}
			})
		}

		let individualCoursesOnly = []
		if (individualCourses.length) {
			individualCourses.map((groupCourses) => {
				let currentCourseData =
					allCourses && allCourses.length
						? allCourses.find((courseId) => courseId.id === groupCourses.id)
						: null
				if (currentCourseData) {
					userProgress.find((userProgressItem) =>
						userProgressItem.course_id === currentCourseData.id
							? Object.assign(currentCourseData, {
									certify_time: userProgressItem['certify_time']
										? userProgressItem['certify_time']
										: null,
									status: userProgressItem.status,
									past_due: userProgressItem.past_due,
									equivalent: userProgressItem['equivalent']
										? userProgressItem['equivalent']
										: null,
							  })
							: null
					)
					individualCoursesOnly.push(currentCourseData)
				}
			})
		}

		if (individualCoursesOnly.length) {
			const sortedIndividualCoursesOnly = individualCoursesOnly
				.slice()
				.sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1))
			const individualCoursesData = {
				name: 'Individual Courses',
				courses: sortedIndividualCoursesOnly,
				type: 'course',
				active: true,
				tags: [],
			}
			groupData.push(individualCoursesData)
		}

		dispatch({ type: types.SET_GROUP_DATA, groupData: groupData })
		dispatch({ type: types.SET_COURSES_DATA, coursesData: coursesData })
		dispatch({ type: types.SET_REPORTS_LOADING, value: false })
	}
}

export const onClickSearch = () => {
	return (dispatch, getState) => {
		const value = getState().report.searchValue
		dispatch({ type: types.SET_SEARCH_VALUE_ON_CLICK, value })
	}
}

export const onSearchReset = () => {
	return (dispatch) => {
		dispatch({ type: types.SET_SEARCH_VALUE_ON_CLICK, value: '' })
		dispatch({ type: types.SET_SEARCH_VALUE, value: '' })
	}
}
